import {
  ActionIcon,
  Group,
  Switch,
  createStyles,
  rem,
  Modal,
  Text,
  Button,
  Box,
  Flex,
  Badge,
} from "@mantine/core";
import { IconEdit, IconEye, IconKey, IconTrash } from "@tabler/icons-react";

import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import StaffModal from "../../containers/StaffModal";
import { forgetPassword } from "../../services/auth";
import { removeStaff, updateStaffStatus } from "../../services/staff";
import { useSelector } from "react-redux";
import MenuDropdown from "../NoteTableRow/MenuDropdown";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { decrypt } from "../../utils";
const useStyles = createStyles((theme) => ({
  StaffSwitchCell: {
    paddingTop: rem(12),
    paddingBottom: rem(12),
    paddingLeft: 20,
    fontFamily: "Inter",
    height: "100%",
  },
  StaffSwitchBtn: {
    height: "32px",
    width: "61px",
  },
  border: {
    borderLeft: "1px solid #F2F2F2",
  },
  bg1: {
    "& td": {
      background: "#fff",
    },
    cursor: "pointer",
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
    cursor: "pointer",
  },
}));

const StaffAttendanceTableRow = ({
  row,
  index,
  track,
  handleRowClick,
  currentPage,
  range,
}) => {
  const { classes } = useStyles();
  const [view, setView] = useState(false);
  const [active, setActive] = useState(row?.active);
  const [opened, { open, close }] = useDisclosure(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const { profile } = useSelector((state) => state?.profile);
  const isAdmin = profile?.user?.id === row?.id;
  const bg = index % 2 === 0;
  const navigate = useNavigate();

  // const staffWithAdminRole =
  //   profile?.user?.type == "staff" && profile?.user?.role == "admin";

  useEffect(() => {
    setActive(row?.active);
  }, [row, active]);

  const handleEditClick = (e) => {
    handleRowClick(row?.id, track?._id, "edit");
  };

  // const handleRowClick = () => {
  //   navigate(`/home/staff/${row.id}/view`);
  // };

  // functions
  // const remove = async () => {
  //   const willDelete = await swal({
  //     title: `Are you sure?`,
  //     text: "This action cannot be undone.",
  //     icon: "warning",
  //     dangerMode: true,
  //     buttons: ["Cancel", "Delete"],
  //   });
  //   if (willDelete) removeStaff(row?.id, () => {}, null);
  // };

  // const resetPassword = async () => {
  //   const email = await swal({
  //     title: `Reset Password`,
  //     text: "Do you want to email reset password link?",
  //     dangerMode: false,
  //     buttons: ["Cancel", "Send"],
  //   });
  //   if (email) {
  //     forgetPassword({ email: row?.email }, "reset");
  //   }
  // };

  // function handleRowClick(event) {
  //   console.log("🚀 ~ handleRowClick ~ event:", event);
  //   setView(true);
  //   open();
  // }

  // const updateStatus = async (isChecked) => {
  //   try {
  //     setActive(isChecked);
  //     const rep = await updateStaffStatus(
  //       { id: row?.id, active: isChecked },
  //       true,
  //       null
  //     );
  //     if (!rep?.success) {
  //       throw new Error("Failed to update staff status");
  //     }
  //   } catch (error) {
  //     setActive((prev) => !prev);
  //   }
  // };

  // Function to handle the switch toggle
  // const handleSwitchToggle = () => {
  //   if (!active) {
  //     if (row?.isEmailVerified) updateStatus(true);
  //     else setConfirmationOpen(true);
  //   } else {
  //     updateStatus(false);
  //   }
  // };

  // const handleConfirmationSubmit = (forceActivate) => {
  //   setConfirmationOpen(false);
  //   updateStatus(forceActivate);
  // };

  function convertSecondsToTime(seconds) {
    const duration = moment.duration(seconds, "seconds");
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    const secs = duration.seconds();

    return `${hours}:${minutes}:${secs}`;
  }

  console.log("track", track);

  const timeZone = track.staff?.timeZone;

  return (
    <tr
      style={{ cursor: "pointer" }}
      className={bg ? classes.bg2 : classes.bg1}
    >
      {/* <td onClick={handleRowClick}>{row?.name || "-"}</td> */}
      <td onClick={() => handleRowClick(row?.id, track?._id, "edit")}>
        {row?.firstName || row?.name || "-"}
      </td>
      <td onClick={() => handleRowClick(row?.id, track?._id, "edit")}>
        {row?.lastName || "-"}
      </td>
      <td onClick={() => handleRowClick(row?.id, track?._id, "edit")}>
        {/* {row?.facilityId?.map((f) => f?.name)?.join(",") || "-"} */}
        {track?.facility?.name || "-"}
      </td>
      <td onClick={() => handleRowClick(row?.id, track?._id, "edit")}>
        {/* {row?.facilityId?.map((f) => f?.name)?.join(",") || "-"} */}
        {decrypt(track?.client?.name) || "-"}
      </td>
      <td onClick={() => handleRowClick(row?.id, track?._id, "edit")}>
        {/* {moment(track?.date?.date).format("MM/DD/YYYY") || "-"} */}
        {track?.date?.date && timeZone
          ? moment.tz(track.date.date, timeZone).format("MM/DD/YYYY")
          : "-"}
      </td>
      <td onClick={() => handleRowClick(row?.id, track?._id, "edit")}>
        {/* {track?.startTime && timeZone
          ? moment.utc(track.startTime).tz(timeZone).format("h:mm A")
          : "-"} */}
        {moment(track?.startTime).format("hh:mm:ss A") || "-"}
        {/* {track?.startTime && timeZone
    ? moment.tz(track.startTime, timeZone).format("hh:mm:ss A")
    : "-"
  } */}
      </td>
      <td onClick={() => handleRowClick(row?.id, track?._id, "edit")}>
        {track?.endTime ? moment(track?.endTime).format("hh:mm:ss A") : "-"}
        {/* {track?.endTime && timeZone
    ? moment.tz(track.endTime, timeZone).format("hh:mm:ss A")
    : "-"
  } */}
      </td>
      <td
        onClick={() => handleRowClick(row?.id, track?._id, "edit")}
        style={{ textTransform: "capitalize" }}
      >
        {track?.total_break_time
          ? convertSecondsToTime(track?.total_break_time)
          : "-"}
      </td>
      <td
        onClick={() => handleRowClick(row?.id, track?._id, "edit")}
        style={{ textTransform: "capitalize" }}
      >
        {track?.total_work_time
          ? convertSecondsToTime(track?.total_work_time)
          : "-"}
      </td>
      <td
        onClick={() => handleRowClick(row?.id, track?._id, "edit")}
        style={{
          color: track?.approvedStatus === "approved" ? "#027A48" : "#6941C6",
          fontWeight: 700,
          textTransform: "capitalize",
        }}
      >
        <Box
          style={{
            backgroundColor:
              track?.approvedStatus === "approved" ? "#E6F8EF" : "#EEEEFB",
            padding: "3px",
            borderRadius: "30px",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "7px",
            fontWeight: "400",
            flexWrap: "wrap",
          }}
        >
          <Badge
            size={10}
            style={{
              backgroundColor:
                track?.approvedStatus === "approved" ? "#12B76A" : "#7A5AF8",
              padding: 0,
              boxSizing: "border-box",
              height: 10,
              width: "10px",
            }}
            // circle
          ></Badge>
          {track?.approvedStatus || "pending"}
        </Box>
      </td>
      <td>
        <MenuDropdown
          isNote={false}
          row={row}
          view={() => handleRowClick(row?.id)}
          isDashboradMode={false}
          startDate={null}
          endDate={null}
          // isStaff={true}
          isAttendance={true}
          edit={handleEditClick}
          disabled={isAdmin}
          isEdit={track?.status === "clock-out"}
          track={track}
          currentPage={currentPage}
          range={range}
        />
      </td>
    </tr>
  );
};

export default StaffAttendanceTableRow;
